import { Component, inject, input, signal, ChangeDetectionStrategy } from '@angular/core';
import { toObservable, takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { filter, switchMap } from 'rxjs';
import { SvgCacheService } from '@services/svg-cache.service';

@Component({
  selector: 'app-svg',
  standalone: true,
  imports: [],
  templateUrl: './svg.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      :host {
        display: inline-block;
      }
      div {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      div::ng-deep svg {
        width: 100%;
        height: 100%;
      }
    `,
  ],
})
export class SvgComponent {
  private svgCache = inject(SvgCacheService);
  private sanitizer = inject(DomSanitizer);

  svgPath = input<string>('');
  width = input<string>('24');
  height = input<string>('24');
  svgContent = signal<SafeHtml>('');

  constructor() {
    toObservable(this.svgPath)
      .pipe(
        filter(Boolean),
        switchMap((path) => this.svgCache.getSvg(path)),
        takeUntilDestroyed(),
      )
      .subscribe((svgData) => {
        this.svgContent.set(this.sanitizer.bypassSecurityTrustHtml(svgData));
      });
  }
}
